.container {
  @media screen and (width >= 600px) {
    width: min-content;
  }
}

.input {
  width: 100%;
}
